import { DefaultButton } from '@fluentui/react';

import { popup } from '../../../../../addons/Popup';
import { deleteIcon } from '../../../../../utils/icons';
import { actions } from '../../../slice';

type Props = {
  skipConfirm?: boolean;
  onCompleted?: (success?: boolean) => any;
};

export default (props: Props) => {
  return (
    <DefaultButton
      text="Taslağı Sil"
      iconProps={deleteIcon}
      onClick={async () => {
        if (!props.skipConfirm) {
          const { cancelled } = await popup({
            title: "Dikkat!",
            message: "Taslak silinsin mi?",
            buttonText: "Sil",
          });

          if (!cancelled) {
            actions.deleteNewForm();
          }

          props.onCompleted?.(!cancelled);
        } else {
          actions.deleteNewForm();
          props.onCompleted?.(true);
        }
      }}
    />
  );
};
